import * as React from 'react';
import { MenuConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import ua from '@tencent/docs-user-agent';
import { MenuKey } from '../../schema/menu-schema/common';
import exportIcon from '@tencent/docs-design-resources/icon/desktop/svg/download_light_24.svg';

const UnusedInWxMiniProgram = !ua.isWxMiniProgram ? [
    {
        name: ActionType.EXPORT_IMAGE,
        content: i18n.t<string>('图片(.png)'),
    },
    {
        name: ActionType.GENERATE_SHORTCUT,
        content: i18n.t<string>('生成本地快捷方式'),
    },
] : [];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: ActionType.EXPORT,
        content: i18n.t<string>('导出为'),
        preventDismiss: true,
        respectOffline: true,
    },
    {
        name: MenuKey.EXPORT_HOR,
        content: i18n.t('下载'),
        icon: <img src={exportIcon} style={{ width: '24px', height: '24px' }} />,
        respectOffline: true,
    },
    {
        name: ActionType.NATIVE_PPT,
        content: i18n.t<string>('本地PPT文档(.pptx)'),
    },
    {
        name: ActionType.EXPORT_PDF,
        content: i18n.t<string>('PDF文档'),
    },
    ...UnusedInWxMiniProgram,
];
